import OrderModal from "@/models/Order";

const GET_ORDER_PAGING_LIST = 'GET_ORDER_PAGING_LIST';
const GET_ORDER_LIST_PAY_INFO = 'GET_ORDER_LIST_PAY_INFO';
const CANCEL_ORDER_LIST = 'CANCEL_ORDER_LIST';
const CANCEL_REFUND_LIST = 'CANCEL_REFUND_LIST';

/**
 * 获取订单列表(分页)
 */
async function getOrderPagingList(params) {
  const payload = await new OrderModal().orderPagingList(params);
  return {
    type: GET_ORDER_PAGING_LIST,
    payload
  }
}

/**
 * 根据订单编号获取支付信息
 * @param {string} tradeCode 订单编号
 */
async function getOrderListPayInfo(tradeCode) {
  const payload = await new OrderModal().getPayInfo(tradeCode);
  return {
    type: GET_ORDER_LIST_PAY_INFO,
    payload
  }
}

/**
 * 取消订单
 * @param {string} tradeCode 订单编号
 */
async function cancelOrderList(tradeCode) {
  await new OrderModal().cancelOrder(tradeCode);
  return {
    type: CANCEL_ORDER_LIST,
    payload: {
      tradeCode
    }
  }
}

/**
 * 取消退单
 * @param {string} refundCode 退单编号
 */
async function cancelRefundList(refundCode) {
  await new OrderModal().cancelRefundOrder(refundCode);
  return {
    type: CANCEL_REFUND_LIST,
    payload: {
      refundCode
    }
  }
}

const ACTION_TYPES = {
  GET_ORDER_PAGING_LIST,
  GET_ORDER_LIST_PAY_INFO,
  CANCEL_ORDER_LIST,
  CANCEL_REFUND_LIST,
};

const ACTION = {
  getOrderPagingList,
  getOrderListPayInfo,
  cancelOrderList,
  cancelRefundList,
};

const OrderList = {
  ACTION_TYPES,
  ACTION
}

export default OrderList;